import React from 'react';
import './index.css';
import Builder from './Builder';

function App() {  
  return (
    <div className="bg-background">
      <Builder size={750} />
    </div>
  );
}

export default App;
